import { IDevicePtPoints } from "@types"
import { protectedApi } from "store/Api"

const devicePtPointsApi = protectedApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchDevicePtPoints: builder.query<IDevicePtPoints[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/pt_points`,
                }
            },
        }),
    }),
})

export const { useFetchDevicePtPointsQuery } = devicePtPointsApi
